import React from 'react';
import ProjectLayout from '../ProjectLayout';
import './ProjectPage.css'; // Custom styles for this project

const DeepAlignment = ({ project }) => {
  return (
    <ProjectLayout project={project} className="cot-page">
      <p>
      <em>TLDR: if you prepend tokens like "Sure, here's how:" to a harmful prompt,
      many models will comply because their safety training only kicks in at the start of generation.
      We wanted to fix that.</em>
      </p>
      <p>
        Recent <a href="https://arxiv.org/abs/2406.05946" target="_blank" rel="noopener noreferrer">
            research
          </a> shows that aligned language models learn "shallow" safety, meaning they refuse harmful requests
        in the first few tokens but remain vulnerable to prefill attacks that bypass these initial refusals. I wanted to see how this worked
        and I wanted to see if we could post-train this feature out of models. We framed the defense against prefill attacks as a POMDP and used reinforcement learning
        to train models toward deeper alignment.
      </p>

      <h4>Here's how I did it</h4>
      <ul>
        <li>Modeled the problem with hidden states (harmful vs. benign),
        observations (token sequences), and a learned reward function for safety</li>
        <li>Fine-tuned Qwen 2.5 models using Group Relative Policy Optimization (GRPO),
        which avoids the need for a separate critic network</li>
        <li>Used LLM-as-a-Judge (Gemini 2.5 Flash) to evaluate response safety,
        after finding that heuristic rewards were too sparse</li>
      </ul>
      <p>This has some pretty cool results! Our trained Qwen 2.5-7B achieved 37.6% attack success rate vs. 40.6% for the base model, and with more personalized prefill attacks, the results could definitely be more clear.
          We also realized that judge model quality matters (Gemini as judge outperformed using the model as its own judge).  </p>

      Definitely planning to flesh this out more, but these are promising results!

      <section className="links-section">
        <h3>Project Links</h3>
        <div className="project-links">
          <a href="files/deepalignment/DeepAlignment.pdf" target="_blank" rel="noopener noreferrer">
            View Paper (PDF)
          </a>
          <a href="https://github.com/lanpouthakoun/Deep_Alignment" target="_blank" rel="noopener noreferrer">
            View Source Code
          </a>
        </div>
      </section>
    </ProjectLayout>
  );
};

export default DeepAlignment;
